var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('processed-image',{staticClass:"avatar",attrs:{"src":_vm.avatarSrc,"transforms":_vm.transforms,"width":_vm.width,"height":_vm.height,"alt":_vm.avatarAltTag,"role":"presentation"},on:{"error":_vm.handleError}})}
var staticRenderFns = []

export { render, staticRenderFns }